<template>
  <div>
    <el-card class="box-card">
      <div>
        <el-card class="form-card">
          <el-form ref="form"
                   v-model="form"
                   :inline="true"
                   class="demo-form-inline"
                   label-width="100px">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="问卷模板名称">
                  <el-input v-model="form.name" style="width: 90%;"></el-input>
                </el-form-item>
                <el-button type="primary" @click="onSubmit">搜索</el-button>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
    </el-card>
    <!-- 模板list -->
    <el-table :data="quesList"
              v-loading="loading"
              :show-overflow-tooltip="true"
              border
              stripe
              :header-cell-style="{'text-align':'center'}"
              style="width: 100%"
              height="500">
      <el-table-column type="index"
                       align="center"
                       label="#"></el-table-column>
      <el-table-column prop="name"
                       label="模板名称"
                       show-overflow-tooltip></el-table-column>
      <el-table-column prop="actName"
                       align="center"
                       label="状态"
                       min-width="80px"></el-table-column>
      <el-table-column prop="profession"
                       label="行业"></el-table-column>
      <el-table-column prop="business"
                       label="商家"></el-table-column>
      <el-table-column prop="store"
                       label="店铺"
                       show-overflow-tooltip></el-table-column>
      
      <el-table-column label="操作"
                       align="center"
                       min-width="80px">
        <template slot-scope="scope">
          <!-- 编辑基本信息 -->
          <el-tooltip effect="dark"
                      content="编辑基本信息"
                      placement="top"
                      :enterable="false">
            <el-button type="primary"
                       icon="el-icon-edit"
                       size="mini"
                       @click="showEditDilog(scope.row)"></el-button>
          </el-tooltip>
          <!-- 编辑字段 -->
          <el-tooltip effect="dark"
                      content="编辑字段"
                      placement="top"
                      :enterable="false">
            <el-button type="success"
                       icon="el-icon-edit"
                       size="mini"
                       @click="showEditFileDilog(scope.row)"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="block">
      <el-pagination @size-change="handleSizeChange"
                     @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]"
                     :page-size="queryInfo.pagesize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="total"></el-pagination>
    </div>
    <!-- 模板基本信息 -->
    <el-dialog title="模板基本信息"
               :visible.sync="editdialogFormVisible"
               width="600px"
               @close="editDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="editform"
               ref="editformRef"
               :rules="rules"
               size="mini">
        <el-form-item label="模板名称"
                      prop="shopName"
                      :label-width="formLabelWidth">
          <el-input v-model="editform.name"
                    autocomplete="on"
                    style="width:80%"></el-input>
        </el-form-item>
        <el-form-item label="状态" prop="actFlag" :label-width="formLabelWidth">
          <el-radio-group v-model="editform.actFlag">
            <el-radio label="T">开启</el-radio>
            <el-radio label="F">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问卷类型" prop="type" :label-width="formLabelWidth">
          <el-select clearable
                         v-model="editform.type"
                         placeholder="请选择"
                         style="width: 100%">
                <el-option v-for="item in queslists"
                           :key="item.type"
                           :label="item.type_name"
                           :value="item.type">{{ item.type_name }}</el-option>
              </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="editdialogFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveShop">保 存</el-button>
      </div>
    </el-dialog>
    <!-- 模板字段 -->
    <el-dialog title="模板字段"
               :visible.sync="editdialogFileFormVisible"
               custom-class="importDialog"
               @close="editDilogClosed"
               :close-on-click-modal="false">
      <el-form :model="editfileform"
               ref="editfileformRef"
               :rules="rules"
               size="mini">
        <!-- el-table -->
        <el-table v-loading="loading"
                  border
                  :data="tableData"
                  row-key="id"
                  style="width: 100%">
            <el-table-column :prop="dropList[index].prop"
                  align="center"
                  header-align="center"
                  v-for="(item, index) in colList"
                  :key="'col_'+index"
                  width="300"
                  :fixed="index == 0 ? true : false"
                  :label="item.label">
                  <template slot-scope="scope">
                    <div class="head" v-if="index == 0">{{scope.row[dropList[index].prop]}}</div>
                    <div class="headcol" v-else>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'text'">
                        <el-input v-model="scope.row[dropList[index].prop].name" style="width: 50%;"></el-input>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'checkbox'">
                        <el-checkbox v-model="scope.row[dropList[index].prop].name" :true-label="'Y'" :false-label="'N'"></el-checkbox>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'select'">
                        <el-select clearable
                              v-model="scope.row[dropList[index].prop].name"
                              placeholder="请选择" style="width: 50%">
                          <el-option label="日期" value="date"></el-option>
                          <el-option label="数字" value="number"></el-option>
                          <el-option label="文字" value="text"></el-option>
                        </el-select>
                      </div>
                      <div class="head" v-if="scope.row[dropList[index].prop].type == 'date'">
                        <el-date-picker v-model="scope.row[dropList[index].prop].value"
                                      type="date"
                                      placeholder="开始日期"
                                      value-format="yyyy-MM-dd"
                                      style="width: 50%;"></el-date-picker>
                      </div>
                    </div>
                  </template>
                  </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer"
           class="dialog-footer"
           style="text-align:center">
        <el-button @click="editdialogFileFormVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="saveFileShop">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dealReturn } from '@/common/js/index.js'
export default {
  data() {
    return {
      form: {
        name: '',
      },
      editform: {
        name: '',
        actFlag: '',
        type: ''
      },
      editfileform: {
        id: ''
      },
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
      },
      quesList: [],
      currentPage: 1,
      total: 0,
      dialogFormVisible: false,
      editdialogFormVisible: false,
      editdialogFileFormVisible: false,
      formLabelWidth: '100px',
      rules: {
        name: [
          { required: true, message: '请输入店铺名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur', },
        ],
        actFlag: [ { required: true, message: '请选择状态', trigger: 'change' },],
      },
      errmsg: '',
      loading: false,
      colList:[],
      dropList:[],
      tableData: [],
      queslists: [],
    }
  },
  mounted() {
    this.rowDrop()
    this.columnDrop()
  },
  methods: {
    // 搜索
    onSubmit() {
      this.queryInfo.pagenum = 1
      this.currentPage = 1
      this.queryInfo.query = this.form
      this.getQuesList()
    },

    // 关闭新增窗口
    addDilogClosed() {
      
    },
    // 显示修改对话框
    async showEditDilog(row) {
      let copy = Object.assign({}, row)
      this.editform = copy
      this.getType()
      this.editdialogFormVisible = true
    },
    // 编辑字段
    async showEditFileDilog(row) {
      this.editfileform.id = row.id
      this.getTablData()
      this.editdialogFileFormVisible = true
    },
    // 问卷类型
    async getType() {
      this.loading = true
      let query = {
        url: 'getType',
        title: '问卷类型',
        method: 'post'
      }
      let parm = {
        query: this.editform
      }
      let { data, err } = await this.axiosApi(
        query,
        parm
      )
      this.queslists = data.data.data
      this.loading = false
    },
    // 列表
    async getTablData() {
      this.loading = true;
      let query = {
        url: 'surTitleDetail',
        title: '列表',
        method: 'post'
      }
      let parm = {
        query: {
          id: this.editfileform.id
        }
      }
      let { data, err } = await this.axiosApi(
        query,
        parm
      );
      this.loading = false
      this.colList = []
      this.dropList = []
      data.data.data.title.forEach(item => {
        if(item.name && item.label){
          this.colList.push({
            label: item.name,
            prop: item.label
          })
        }
      })
      this.dropList = this.colList
      this.tableData = data.data.data.list
      this.total = parseInt(data.data.data.total)
      dealReturn(data, err);
    },
    // 行拖拽
    rowDrop () {
      const tbody = document.querySelector('.el-table__body-wrapper tbody')
      const _this = this
      this.$Sortable.create(tbody, { draggable: ".el-table__row",
        onEnd ({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0]
          _this.tableData.splice(newIndex, 0, currRow)
          console.log(_this.tableData, 'tableData')
        }
      })
    },
    // 列拖拽
    columnDrop () {
      const wrapperTr = document.querySelector('.el-table__header-wrapper tr')
      this.sortable = this.$Sortable.create(wrapperTr, { animation: 180, delay: 0,
        onEnd: evt => {
          const oldItem = this.dropList[evt.oldIndex]
          this.dropList.splice(evt.oldIndex, 1)
          this.dropList.splice(evt.newIndex, 0, oldItem)
        }
      })
    },
    // 列表
    getQuesList() {
      this.loading = true
      let parm = {
        query: this.form
      }
      this.$http
        .post('surList', parm)
        .then((response) => {
          this.quesList = response.data.data.data
          this.loading = false
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
          this.loading = false
        })
    },
    handleSizeChange() {},
    handleCurrentChange() {},
    editDilogClosed() {},
    // 保存编辑店铺信息
    saveShop() {
      // this.$refs.editformRef.validate(async (valid) => {
      //   if (!valid) return;

      this.$http
        .post('surStore', this.editform)
        .then((response) => {
          const res = response.data

          this.$message.success('编辑成功')
          this.editdialogFormVisible = false
          this.onSubmit()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
      // });
    },
    // 保存编辑字段 editfileform
    saveFileShop() {
      let parm = {
        query: this.tableData
      }
      Object.assign(parm, this.editfileform)
      if(!this.duplicateSel(parm)){
        this.$confirm('您的去重项没有选择，是否确定保存？', '提示',{ confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning'})
          .then(() => {
            this.smtFileShop(parm)
          }).catch(() => {
            // this.$message({type: 'info', message: '已取消'})
          })
      }else{
        this.smtFileShop(parm)
      }
    },
    smtFileShop(parm) {
      this.$http
        .post('surStore', parm)
        .then((response) => {
          const res = response.data

          this.$message.success('编辑成功')
          this.editdialogFileFormVisible = false
          this.onSubmit()
        })
        .catch((error) => {
          return this.$message.error(error.response.data.message)
        })
    },
    // 去重项
    duplicateSel(e) {
      let s = false
      e.query.forEach((item, index) => {
        if(item.表头 == '去重项'){
          let optlist = Object.values(item)
          optlist.forEach((itm, idx) => {
            if(typeof(itm) == 'object'){
              if(itm.name == 'Y'){
                s = true
              }
            }
          })
        }
      })
      return s
    },
  },
  created() {
    this.getQuesList()
  },
}
</script>

<style lang="scss" scoped>
.el-dialog__wrapper {
 >>>.importDialog {
   color: #000;
    width: 80%;
  }
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.form-card {
  margin-bottom: 15px;
}
.add-card {
  width: 50%;
}
.el-dialog {
  /* 表单页面居中，宽度50% ,legend颜色设置，legend圆角*/
  border: 2px solid #dcdfe6;
  text-align: center;
  border-radius: 8px;
  margin: 0 auto;
  width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/basic/quest.vue